var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"aria-label":"Print Page"},on:{"click":function($event){return _vm.printPage()}}},[_c('font-awesome-icon',{attrs:{"icon":"print"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }